export function printLogo() {
    // 테스트 환경에서는 로고를 출력하지 않음
    if (
        process.env.NODE_ENV === 'test' ||
        process.env.VITEST === 'true' ||
        (typeof global !== 'undefined' && (global as any).__VITEST__)
    ) {
        return;
    }

    console.log(
        '\x1b[36m%s\x1b[0m',
        `
██████╗ ██╗       ██████╗  ██╗   ██╗ ██████╗       █████╗  ██████╗  ██╗
██╔════╝ ██║      ██╔═══██╗ ██║   ██║ ██╔══██╗     ██╔══██╗ ██╔══██╗ ██║
██║      ██║      ██║   ██║ ██║   ██║ ██║  ██║     ███████║ ██████╔╝ ██║
██║      ██║      ██║   ██║ ██║   ██║ ██║  ██║     ██╔══██║ ██╔═══╝  ██║
╚██████╗ ███████╗ ╚██████╔╝ ╚██████╔╝ ██████╔╝     ██║  ██║ ██║      ██║
 ╚═════╝ ╚══════╝  ╚═════╝   ╚═════╝  ╚═════╝      ╚═╝  ╚═╝ ╚═╝      ╚═╝
`,
    );
}
